module.exports = __webpack_public_path__ + "img/xqxh10.0db14217.png";